import { z } from "zod";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum ItemSoldFilterQuery {
  IS_GREATER_THAN = "isGreaterThan",
  IS_LESS_THAN = "isLessThan",
  WITHIN = "within",
}

export const ItemSoldFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.NUM_SOLD,
  ItemSoldFilterQuery,
  z.union([z.number(), z.object({ min: z.number(), max: z.number() })]),
);

export type ItemSoldFilter = z.infer<typeof ItemSoldFilterSchema>;
